import { baseUrl } from '@/config/env';
import request from '@/router/axios';
import { parseParam } from '@/util/util';
//查询服务热线
export const getList =()=>{
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/service-hotline/list`,
        method: 'GET'
    })
}
//新增服务热线
export const add = (data) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/service-hotline`,
        method: 'POST',
        data: data
    })
}
//修改服务热线
export const update = (data) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/service-hotline`,
        method: 'PUT',
        data: data
    })
}
//删除服务热线
export const del = (id) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/service-hotline/${id}`,
        method: 'DELETE'
    })
}
